import {
  Box,
  FormHelperText,
  InputLabel,
  TextField as MuiTextField,
  TextFieldProps,
} from '@mui/material'
import React from 'react'
import { theme } from 'Providers/ThemeProvider'

const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  ({ error, helperText, label, fullWidth = true, sx, ...rest }, ref) => {
    return (
      <Box
        width={fullWidth ? '100%' : 'auto'}
        display="flex"
        flexDirection="column"
        gap={0.5}
      >
        <InputLabel
          sx={theme => ({
            color: theme.palette.common.black,
            fontWeight: 400,
            fontSize: 12,
          })}
          id="input-label"
        >
          {label}
        </InputLabel>
        <MuiTextField
          {...rest}
          sx={{
            '& input': {
              padding: theme.spacing(1),
            },
            ...{ ...sx },
          }}
          error={error}
          fullWidth={fullWidth}
          variant="outlined"
          ref={ref}
        />
        {helperText && <FormHelperText error>{helperText}</FormHelperText>}
      </Box>
    )
  }
)

export default TextField
